export default __webpack_public_path__ + "static/media/profile.062a8e30.svg";